import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

export class TemplateSchemaPlugin extends SchemaPlugin {
  nodes = {
    template: {
      group: 'inline',
      inline: true,
      attrs: {
        content: { default: undefined, skipExport: true, skipEditorExport: true }
      },
      parseDOM: [{
        tag: 'template',
        getAttrs(dom: HTMLElement) {
          return {
            content: dom.outerHTML
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        return nodeToFlareXML(node, options, 'template', {
          xml: node.attrs.content
        });
      },
      editorTagName: 'mc-lwe-template',
      isTagNameBox: true,
      noStyles: true
    }
  } satisfies Record<string, NodeSpec>;
}
